import React, { useState } from 'react';
import axios from 'axios';
import { host_url } from '../../../App'; // Import host_url
import BackArrow from '../../../BackArrow'; // Importiere die BackArrow-Komponente


function Pabrika() {
  const [name, setName] = useState('');
  const [antrag, setAntrag] = useState('');
  const [bereich, setBereich] = useState('');
  const [error, setError] = useState('');
  const [submissionStatus, setSubmissionStatus] = useState(null); // Add state for submission status

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  };
  const bereichCookie = getCookie('Bereich');
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name || !antrag || !bereich) {
      setError('Bitte fülle alle Felder aus.');
      return;
    }

    // Show confirmation popup
    const confirmed = window.confirm('Möchtest du diesen Antrag absenden?');

    if (!confirmed) {
      return; // Do nothing if not confirmed
    } else {
      setError(''); // Clear the error message if all fields are filled
    }


    axios.post(`${host_url}/pabrika`, {
      name,
      antrag,
      bereich
    })
    .then(response => {
      console.log('Data saved:', response.data);
      setSubmissionStatus('success'); // Set submission status to success
    })
    .catch(error => {
      console.error('Error saving data:', error);
      setSubmissionStatus('error'); // Set submission status to error
    });
  };

  return (
    <div>
      <div className="page-header">
        <BackArrow to="/parlament" />
        <h1>Pabrika</h1>
      </div>
      {error && (
        <div className="error-message">{error}</div>
      )}
      {submissionStatus === 'success' && (
        <div>
          <h2>Dein Antrag wurde erfolgreich abgesendet.</h2>
          <button onClick={() => window.location.reload()} className={`bereich_button ${bereichCookie ? bereichCookie.replace(/[^a-zA-Z0-9]/g, '-') : ''}`}>Neuen Antrag stellen</button>
        </div>
      )}
      {submissionStatus === 'error' && (
        <div>
          <h2>Ein Fehler ist aufgetreten. Bitte versuche es erneut.</h2>
          <button className="btn-secondary" onClick={() => setSubmissionStatus(null)}>Zurück</button>
        </div>
      )}
      {submissionStatus === null && (
        <form onSubmit={handleSubmit}>
          <div>
          <label className="freitext-label">Name</label>
            <input
              className="freitext-input"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Nenne deinen Namen"
              required
            />
          </div>
          <div>
          <label className="freitext-label">Antrag</label>
            <textarea
              className="freitext-input"
              value={antrag}
              onChange={(e) => setAntrag(e.target.value)}
              placeholder="Schreibe dein Anliegen an das Parlament"
              required
            />
          </div>
          <div>
          <label className="freitext-label">Zelt/Bereich</label>
            <input
              className="freitext-input"
              type="text"
              value={bereich}
              onChange={(e) => setBereich(e.target.value)}
              placeholder="Nenne dein Zelt/deinen Bereich"
            />
          </div>
          <button type="submit" className={`bereich_button ${bereichCookie ? bereichCookie.replace(/[^a-zA-Z0-9]/g, '-') : ''}`}>Abschicken</button>
        </form>
      )}
    </div>
  );
}

export default Pabrika;
